import {Injectable} from "@angular/core";
import {CookieService} from "ngx-cookie-service";
import {HttpClient} from "@angular/common/http";
import {AuthResponse} from "../entities/auth/AuthResponse";
import {BasicEventPlayer} from "../entities/auth/BasicEventPlayer";
import {ActivatedRouteSnapshot, Router} from "@angular/router";
import {APIService} from "./APIService";
import {BaseResponse} from "../entities/BaseResponse";

@Injectable()
export class AuthService {
  baseUrl: string = "https://api.cubedcon.com/v2/auth";

  public user: BasicEventPlayer | undefined;

  constructor(private cookieService: CookieService,
              private httpClient: HttpClient,
              private apiService: APIService) {
  }

  hasPermission(player: BasicEventPlayer): boolean {
    return this.apiService.hasEntitlement(player.entitlements, 'STAFF');
  }

  invalidateSession() {
    this.cookieService.delete(".CUBEDAUTH", undefined, ".cubedcon.com");
    this.user = undefined;
  }

  async checkRedirect(route: ActivatedRouteSnapshot): Promise<Boolean> {
    return this.cookieService.get(".CUBEDAUTH").length === 0 || this.user === undefined;
  }

  async checkAuthorized(route: ActivatedRouteSnapshot): Promise<Boolean> {
    const cookie = this.cookieService.get(".CUBEDAUTH")
    if (cookie.trim().length !== 0) {
      if (this.user === undefined) {
        try {
          this.user = await this.me();
        } catch (e) {
          console.error(e);
          this.invalidateSession();
          return false;
        }
      }

      return this.hasPermission(this.user);
    }

    return false;
  }

  me(): Promise<BasicEventPlayer> {
    return new Promise((resolve, reject) => {
      this.httpClient.get<BaseResponse<BasicEventPlayer>>(this.baseUrl + "/me").subscribe({
        next: value => {
          if(value.ok)
            resolve(value.response!);
          reject(value.message);
        },
        error: err => {
          reject(err);
        }
      })
    })
  }
}
